import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";

const CUSTOM_BREAKPOINT_DIFFERENCE = 140;

export const GroupedLinksContainerMobile = styled(Grid)(({ theme }) => {
  return {
    ".MuiAccordionSummary-root": {
      paddingRight: "1px",
    },
    [theme.breakpoints.up("md")]: {
      marginBottom: theme.spacing(8),
    },

    [theme.breakpoints.up(
      theme.breakpoints.values.sm + CUSTOM_BREAKPOINT_DIFFERENCE, // 700px
    )]: { display: "none" },
  };
});
export const GroupedLinksContainerDesktop = styled(Grid)(({ theme }) => {
  return {
    [theme.breakpoints.up("md")]: {
      marginBottom: theme.spacing(8),
    },

    display: "none",
    [theme.breakpoints.up(
      theme.breakpoints.values.sm + CUSTOM_BREAKPOINT_DIFFERENCE, // 700px
    )]: { display: "flex" },
  };
});
